import { useRouter } from "next/router";

import localeCore from "../../core/locale.core";
import productCore from "../../core/product.core";
import { useTranslation } from "../../core/translation.core";
import { Product } from "../../types/product";

export default function Availability({ product }: { product: Product }) {
  const { t, msg } = useTranslation();
  const { locale, isReady } = useRouter();

  const rst = productCore.getAvailabilityStatus(product);

  if (rst.availability === "in") {
    return (
      <p className="text-green-600">
        {t(msg.product.availibility)} {t(msg.product.inStock)}
      </p>
    );
  }

  if (rst.canOrder) {
    if (!isReady) return null;
    return <p className="text-red-400">缺貨中，預約返貨日期：{localeCore.getDateFormat(rst.stockReadyDate!, locale!)}</p>;
  }

  return (
    <p className="text-red-400">
      {t(msg.product.availibility)} {t(msg.product.outOfStock)}
    </p>
  );
}
